var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "signature" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "10px" } },
          [
            _c("span", [_vm._v("Otomatik Ekleme")]),
            _vm._v(" "),
            _c("a-switch", {
              staticClass: "ml-2 mr-2",
              attrs: { size: "small", disabled: _vm.editorContent === "" },
              on: { change: _vm.changeSignatureAuto },
              model: {
                value: _vm.isAutoAdd,
                callback: function ($$v) {
                  _vm.isAutoAdd = $$v
                },
                expression: "isAutoAdd",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "50%" } },
          [
            _c(
              "b-form-group",
              {
                staticClass: "form-group-user",
                attrs: {
                  label: _vm.$t("mail.mailSelecting"),
                  "label-for": "type-input",
                },
              },
              [
                _c(
                  "b-form-select",
                  {
                    attrs: {
                      id: "type-input",
                      "data-vv-as": _vm.$t("message.contentType"),
                      name: _vm.$t("message.contentType"),
                      type: "text",
                    },
                    model: {
                      value: _vm.selectedMail,
                      callback: function ($$v) {
                        _vm.selectedMail = $$v
                      },
                      expression: "selectedMail",
                    },
                  },
                  _vm._l(_vm.mailOptions, function (mail) {
                    return _c("option", { domProps: { value: mail.mail } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(mail.mail) +
                          "\n                    "
                      ),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("quill-editor", {
              ref: "signatureEditor",
              staticStyle: { "max-height": "14%", width: "58vw" },
              attrs: { id: "editor", options: _vm.editorOption },
              on: {
                change: function ($event) {
                  return _vm.onEditorChange($event)
                },
              },
              model: {
                value: _vm.editorContent,
                callback: function ($$v) {
                  _vm.editorContent = $$v
                },
                expression: "editorContent",
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "emoji-icon-wrapper",
                attrs: { id: "emoji-input" },
                on: { click: _vm.emojiClickHandler },
              },
              [
                _c(
                  "md-icon",
                  {
                    staticClass: "input-emoji-icon",
                    staticStyle: { cursor: "pointer" },
                  },
                  [_vm._v(" sentiment_very_satisfied")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.showEmojiTable
              ? _c(
                  "div",
                  {
                    staticClass: "emoji-table-container",
                    attrs: { id: "signature-emoji" },
                  },
                  [
                    _c("EmojiPicker", {
                      attrs: {
                        onBlur: _vm.test,
                        onEmojiPicked: _vm._handleEmojiPicked,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "70px" } }, [
          _c(
            "button",
            { staticClass: "save", on: { click: _vm.saveSignature } },
            [_vm._v(_vm._s(_vm.$t("chatbotv2.save")))]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }